import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "block-content pt-4 pr-4"
};
const _hoisted_2 = {
  class: "m-4 p-2 space-y-2"
};
const _hoisted_3 = {
  key: 0,
  class: "px-4 py-2"
};
const _hoisted_4 = {
  class: "text-base font-semibold"
};
const _hoisted_5 = {
  key: 1,
  class: "px-4 py-2"
};
const _hoisted_6 = {
  class: "text-base font-semibold"
};
const _hoisted_7 = {
  key: 2,
  class: "px-4 py-2"
};
const _hoisted_8 = {
  class: "text-base font-semibold"
};
const _hoisted_9 = {
  key: 3,
  class: "px-4 py-2"
};
const _hoisted_10 = {
  class: "text-base font-semibold"
};
const _hoisted_11 = {
  class: "px-4 py-2"
};
const _hoisted_12 = {
  class: "px-2 py-4 flex justify-between"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  return _openBlock(), _createElementBlock("div", {
    class: "ts modal-wrapper",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
  }, [_createElementVNode("div", {
    class: "ts modal",
    style: {
      "top": "30px",
      "right": "-8%",
      "width": "40%"
    },
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(), _createElementBlock("svg", {
    onClick: _cache[0] || (_cache[0] = $event => $setup.handleCloseButton()),
    width: "14",
    height: "14",
    class: "close-btn float-right cursor-pointer",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [...(_cache[5] || (_cache[5] = [_createElementVNode("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#727272"
  }, [_createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2"
  }), _createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
  })], -1)]))]))]), _createElementVNode("div", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("div", {
    class: "flex justify-center py-3"
  }, [_createElementVNode("span", {
    class: "fa fa-warning fa-5x text-error"
  })], -1)), _cache[13] || (_cache[13] = _createElementVNode("div", {
    class: "flex justify-center py-3"
  }, [_createElementVNode("h3", null, "Deleting Field Mapping")], -1)), $setup.customFieldStore.customFieldSummary.totalClients ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[6] || (_cache[6] = _createTextVNode(" Your are about to delete this fields on: ", -1)), _createElementVNode("span", _hoisted_4, _toDisplayString($setup.customFieldStore.customFieldSummary.totalClients) + " Clients ", 1)])) : _createCommentVNode("", true), $setup.customFieldStore.customFieldSummary.totalMatters ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[7] || (_cache[7] = _createTextVNode(" Your are about to delete this fields on: ", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString($setup.customFieldStore.customFieldSummary.totalMatters) + " Matters ", 1)])) : _createCommentVNode("", true), $setup.customFieldStore.customFieldSummary.totalUsers || $setup.customFieldStore.customFieldSummary.totalAccounts ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[8] || (_cache[8] = _createTextVNode(" Your are about to delete this fields on: ", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString($setup.customFieldStore.customFieldSummary.totalUsers || $setup.customFieldStore.customFieldSummary.totalAccounts) + " Users ", 1)])) : _createCommentVNode("", true), $setup.customFieldStore.customFieldSummary.totalCharges ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[9] || (_cache[9] = _createTextVNode(" Your are about to delete this fields on: ", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString($setup.customFieldStore.customFieldSummary.totalCharges) + " Fixed Fees ", 1)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("span", _hoisted_11, "This will no longer show up in the Invoice Memo.", 512), [[_vShow, $setup.customFieldStore.customFieldToDelete.showOnInvoice]]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_LlSecondaryButton, {
    name: "reject",
    onClick: _cache[1] || (_cache[1] = $event => $setup.handleCloseButton())
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Cancel ", -1)]))]),
    _: 1
  }), _createVNode(_component_LlSecondaryButton, {
    color: "error",
    onClick: _cache[2] || (_cache[2] = $event => $setup.deleteNow())
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("i", {
      class: "fa fa-trash mr-2"
    }, null, -1), _createTextVNode(" Delete ", -1)]))]),
    _: 1
  })])])])]);
}